import { render, staticRenderFns } from "./UnavailabilityCard.vue?vue&type=template&id=631a5783&scoped=true&"
import script from "./UnavailabilityCard.vue?vue&type=script&lang=js&"
export * from "./UnavailabilityCard.vue?vue&type=script&lang=js&"
import style0 from "./UnavailabilityCard.vue?vue&type=style&index=0&id=631a5783&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a5783",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('631a5783')) {
      api.createRecord('631a5783', component.options)
    } else {
      api.reload('631a5783', component.options)
    }
    module.hot.accept("./UnavailabilityCard.vue?vue&type=template&id=631a5783&scoped=true&", function () {
      api.rerender('631a5783', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/staffs/UnavailabilityCard.vue"
export default component.exports